/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import McAnswerQueryResult from './McAnswerQueryResult';
import McMcTranslationParam from './McMcTranslationParam';

/**
 * The McQueryResult model module.
 * @module model/McQueryResult
 * @version 1.0
 */
class McQueryResult {
    /**
     * Constructs a new <code>McQueryResult</code>.
     * @alias module:model/McQueryResult
     */
    constructor() { 
        
        McQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McQueryResult} obj Optional instance to populate.
     * @return {module:model/McQueryResult} The populated <code>McQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McQueryResult();

            if (data.hasOwnProperty('answers')) {
                obj['answers'] = ApiClient.convertToType(data['answers'], [McAnswerQueryResult]);
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('explanation')) {
                obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('question')) {
                obj['question'] = ApiClient.convertToType(data['question'], 'String');
            }
            if (data.hasOwnProperty('translation')) {
                obj['translation'] = ApiClient.convertToType(data['translation'], {'String': McMcTranslationParam});
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/McAnswerQueryResult>} answers
 */
McQueryResult.prototype['answers'] = undefined;

/**
 * @member {String} createdAt
 */
McQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} deletedAt
 */
McQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {String} explanation
 */
McQueryResult.prototype['explanation'] = undefined;

/**
 * @member {Number} id
 */
McQueryResult.prototype['id'] = undefined;

/**
 * @member {String} question
 */
McQueryResult.prototype['question'] = undefined;

/**
 * @member {Object.<String, module:model/McMcTranslationParam>} translation
 */
McQueryResult.prototype['translation'] = undefined;

/**
 * @member {String} updatedAt
 */
McQueryResult.prototype['updatedAt'] = undefined;






export default McQueryResult;

